import { getElementById, attachEventToElements, AppHooksType, updateCssClass, forEach, preloadImg } from './utils';

let lastTitleGroup = '';
let lastTitleElement: HTMLElement = null;
let lastItemElement: HTMLElement = null;

export function init(appHooks: AppHooksType) {
    appHooks.onwebp = onwebp;

    const featuresImg = getElementById('features-img') as HTMLImageElement;
    const figureHint = getElementById('figure-hint') as HTMLDivElement;
    const featuresItems = $('ol.all-features > li');

    function mouseOverListItem(itemElement: HTMLElement) {
        const titleElement = $('h3', itemElement.parentElement.parentElement)[0];
        const header = titleElement.innerText.trim();
        const subheader = itemElement.innerText.trim();

        const image = itemElement.dataset['image'];
        featuresImg.src = `images/${image}`;
        figureHint.innerText = `${header} / ${subheader}`;

        updateCssClass(itemElement, 'list-item-hover', 'set');

        if (lastItemElement !== null && lastItemElement !== itemElement) {
            updateCssClass(lastItemElement, 'list-item-hover', 'remove');
        }

        const group = titleElement.parentElement.dataset['group'];
        if (group !== lastTitleGroup) {
            if (lastTitleElement) {
                updateCssClass(lastTitleElement, 'list-item-hover', 'remove');
            }

            updateCssClass(titleElement, 'list-item-hover', 'set');
            lastTitleElement = titleElement;
            lastTitleGroup = group;
        }

        lastItemElement = itemElement;
    }

    attachEventToElements(featuresItems, 'mouseenter', function (event: MouseEvent) {
        const itemElement = event.currentTarget as HTMLElement;
        if (itemElement && itemElement.tagName === 'LI') {
            mouseOverListItem(itemElement);
        }
    });


    const featuresCategories = $('h3.feature-title');
    attachEventToElements(featuresCategories, 'click', function (event: MouseEvent) {
        const groupElement = event.currentTarget as HTMLElement;
        if (groupElement && groupElement.tagName === 'H3') {
            const groupContentElement = groupElement.nextElementSibling as HTMLElement;
            if (groupContentElement && groupContentElement.tagName === 'OL') {
                if (toggledisplay(groupContentElement)) {
                    const firstItem = $('li:first', groupContentElement)[0] as HTMLElement;
                    mouseOverListItem(firstItem);
                }
            }
        }
    });
}

function toggledisplay(element: HTMLElement): boolean {
    if (element.classList.contains('d-none')) {
        element.classList.remove('d-none');
        return true;
    }

    element.classList.add('d-none');
    return false;
}

function onwebp() {
    const imagesToPreload = {};

    let idx = 1;
    forEach($('li[data-image]'), (element: HTMLElement) => {
        const image = element.dataset['image'];
        imagesToPreload[`_image${idx}`] = image;
        idx++;
    });

    Modernizr.on('webp', function (supported) {
        for (var imgId in imagesToPreload) {
            if (imagesToPreload.hasOwnProperty(imgId)) {
                var imageFile = imagesToPreload[imgId];
                supported = false;
                preloadImg(imageFile, supported, imgId);
            }
        }
    });
}